import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
  Autocomplete,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  CheckCircleOutline,
  DoDisturbAlt,
  MoreVert,
  AddCircle,
  RemoveCircle,
  Edit,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  Delete,
  KeyboardReturn,
  Close,
} from "@mui/icons-material";
import {
  get_customer_contact,
  get_customer_detail,
  get_orders_detail,
  get_orders_history_admin,
  get_report_reason,
  get_sales_order_report_detail,
  manual_customer_return_order,
  reject_report,
  submit_return_report,
  upload_item_images,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";

export default function GroupReturn() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [page, setPage] = React.useState(params.return_type);

  const [loading, setLoading] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);
  const [reasonData, setReasonData] = React.useState(null);
  const [salesOrderReportID, setSalesOrderReportID] = React.useState(null);
  const [selectedReason, setSelectedReason] = React.useState("0");
  const [reportData, setReportData] = React.useState({
    invoiceid: "",
    returnreason: "",
    otherreason: "",
    // fullreturn: "",
    item: "",
  });
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [stockReturn, setStockReturn] = React.useState(false);

  const [fullReturn, setFullReturn] = React.useState(false);

  const [retunDetailData, setRetunDetailData] = React.useState([]);

  const [memo, setMemo] = React.useState({
    description: "",
  });

  const [checked, setChecked] = React.useState(false);
  const [defaultChecked, setDefaultChecked] = React.useState("");
  const [imageList, setImageList] = React.useState([]);

  const [prodList, setProdList] = React.useState([]);
  const [currentQty, setCurrentQty] = React.useState({});
  const [chooseReturn, setChooseReturn] = React.useState(3);
  // const [choosedReturn, setChoosedReturn] = React.useState("");

  const [qty, setQty] = React.useState([]);

  const handleChooseReason = (e) => {
    setSelectedReason(e.target.value);
  };

  const handleChooseReturn = (e) => {
    setChooseReturn(e.target.value);
    // setChoosedReturn(e.target.value);
  };

  const getData = () => {
    setLoading(true);
    get_customer_contact({
      page: 1,
    }).then((json) => {
      setLoading(false);
      setCustomer(json.data);
    });

    get_report_reason({}).then((json) => {
      setLoading(false);

      setReasonData(json.data);
    });
  };

  React.useEffect(() => {
    getData();
  }, [salesOrderReportID]);

  const handleChangeMemo = (e) => {
    setMemo(e.target.value);
  };

  const [uploadReturn, setUploadReturn] = React.useState("");

  const [disabled, setDisabled] = React.useState(false);

  const handleChangeUploadReturn = async (e) => {
    var formData = new FormData();
    const files = e.target.files;
    formData.append("image_length", files.length);
    for (let i = 0; i < files.length; i++) {
      formData.append("images_" + i, files[i]);
    }
    setDisabled(true);
    upload_item_images(formData).then((res) => {
      if (res.status) {
        setDisabled(false);
        setUploadReturn({
          image: JSON.stringify(res.data.data),
        });
      }
    });
  };

  const handleSubmitReport = () => {
    var temp_itemDataAll = orderData.item;
    var temp_itemDataSelected = [];

    var itemCheck = false;

    for (var i = 0; i < selectedItem.length; i++) {
      if (selectedItem[i]["check"] == true) {
        temp_itemDataSelected.push(selectedItem[i]);
        itemCheck = true;
      }
    }
    if (itemCheck == false) {
      toast("Please Select Item");
      setLoading(false);
      return;
    }
    if (selectedReason == "" || selectedReason == undefined) {
      toast("Please Select a Reason");
      setLoading(false);
      return;
    }

    if (chooseReturn == "" || chooseReturn == undefined) {
      toast("Please Select a Return Type");
      setLoading(false);
      return;
    }

    // console.log(uploadReturn);

    if (imageList == []) {
      toast("Please Upload an Image");
      setLoading(false);
      return;
    }

    if (selectedReason == "Others" && reasonData.otherreason == "") {
      toast("Please tell a reason");
      setLoading(false);
      return;
    }
    // console.log(temp_itemDataSelected);
    setLoading(true);

    let postparam = {
      ...reportData,
      // ...retunDetailData,
      ...uploadReturn,
      memo: memo,
      sales_order_id: selectedSaleOrderID.sales_order_id,
      //   sales_order_report_id: params.sales_order_report_id,
      // stockreturn: stockReturn ? 1 : 0,
      stockReturn: chooseReturn,
      fullReturn: fullReturn ? 1 : 0,
      invoiceid: orderData.invoiceid,
      returnreason: selectedReason,
      customer_id: selectedCustomer.customer_id,

      // otherreason: selectedReason == "Others" ? reportData.otherreason : "",
      // fullreturn: params.return_type == 0 ? 1 : 0,
      // item:
      //   params.return_type == 0
      //     ? JSON.stringify(temp_itemDataAll)
      //     : JSON.stringify(temp_itemDataSelected),
      item: JSON.stringify(temp_itemDataSelected),
    };

    // console.log(JSON.stringify(temp_itemDataSelected));
    console.log(JSON.stringify(postparam));

    // submit_return_report(postparam).then((json) => {
    //   if (typeof json.status !== "undefined") {
    //     alert(json.message);
    //     setLoading(false);
    //     return;
    //   } else {
    //     toast("Return Report Submitted");
    //     navigate("/salereturnlist/" + params.sales_order_id);
    //   }
    // });
  };

  const handleChangeReport = (e) => {
    setReportData({
      ...reportData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectItem = (index) => {
    var temp_data = [...selectedItem];
    temp_data[index]["check"] = !temp_data[index]["check"];
    // setSelectedItem(temp_data);

    if (temp_data[index]["check"] && !temp_data[index]["return_quantity"]) {
      // if item is checked and return_quantity is empty, alert the user
      alert("Please enter a value for return_quantity");
    } else {
      setSelectedItem(temp_data);
    }

    // console.log(temp_data);
  };

  const [allSelected, setAllSelected] = React.useState(false);

  const handleSelectAll = () => {
    var temp_data = [...selectedItem];
    const allSelected = temp_data.every((item) => item.check);

    if (!allSelected) {
      temp_data = temp_data.map((item) => ({ ...item, check: true }));
      setFullReturn(true);
    } else {
      temp_data = temp_data.map((item) => ({ ...item, check: false }));
      setFullReturn(false);
    }

    setSelectedItem(temp_data);
    setAllSelected(!allSelected);
  };

  const handleChangeQuantityItem = (e, index) => {
    var temp_data = [...selectedItem];
    var newQty = parseInt(e.target.value);
    if (isNaN(newQty)) {
      temp_data[index].return_quantity = "";
    } else {
      temp_data[index].return_quantity = newQty;
    }

    setSelectedItem(temp_data);
  };

  const [token, setToken] = React.useState([]);

  React.useEffect(() => {
    let token = window.localStorage.getItem("token");
    setToken(token || "");
  }, []);

  const [loadingAdd, setLoadingAdd] = React.useState(false);

  const handleRejectReturn = () => {
    setLoadingAdd(true);
    reject_report({
      sales_order_id: params.sales_order_id,
      sales_order_report_id: params.sales_order_report_id,
      token: token,
    }).then((json) => {
      if (json.status) {
        alert("Reject Successfully");
        window.location.reload();
      }
    });
  };

  const [customer, setCustomer] = React.useState(null);
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);

  const [displayAllSaleOrderID, setDisplayAllSaleOrderID] =
    React.useState(null);
  const [selectedSaleOrderID, setSelectedSaleOrderID] = React.useState(null);

  const [billtype, setBilltype] = React.useState(null);

  const handleGetCustomerData = (e) => {
    // console.log('e,e', e)
    if (e !== "") {
      get_customer_detail({
        customer_id: e,
      }).then((json) => {
        if (json.data.subsidiary == 2) {
          setBilltype("SST");
        } else {
          setBilltype("GST");
        }

        get_orders_history_admin({ customer_id: e, page: 1 }).then((json) => {
          setDisplayAllSaleOrderID(json.data);
          console.log(json.data);
        });
      });
    }
  };

  const handleGetOrderData = (e) => {
    var temp_data = [];
    if (e !== "") {
      get_orders_detail({ sales_order_id: e }).then((json) => {
        setOrderData(json.data);
      });

      get_sales_order_report_detail({
        sales_order_id: e,
        sales_order_report_id: 0,
      }).then((json) => {
        setRetunDetailData(json.data);
        setProdList(json.item);

        for (var i = 0; i < json.item.length; i++) {
          var a = json.item[i].quantity;
          setCurrentQty(a);
        }

        if (json.item.length != 0) {
          for (var j = 0; j < json.item.length; j++) {
            if (json.item[j].is_report == 1) {
              temp_data.push({
                ...json.item[j],
                check: true,
              });
            } else {
              temp_data.push({
                ...json.item[j],
                check: false,
              });
            }
          }
          setSelectedItem(temp_data);
        }
      });
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          <Navbar2
            children={
              <Section pd="2rem">
                <React.Fragment>
                  <div>
                    <div
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <Paragraph
                        color="#000"
                        bold="400"
                        size="12px"
                        margin="0 0 1rem"
                      >
                        &lt; Back
                      </Paragraph>
                    </div>
                    <div className={classes.theFlexHeader}>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Group Return
                      </Paragraph>
                    </div>
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />

                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        sx={{ alignItems: "baseline" }}
                      >
                        <Grid
                          container
                          spacing={3}
                          sx={{ alignItems: "baseline" }}
                        >
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">Customer:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Autocomplete
                              sx={{ fontStyle: "italic" }}
                              id="customer_contact_id"
                              value={selectedCustomer}
                              options={customer || []} // Ensure options is always an array
                              getOptionLabel={(option) =>
                                option.entityid + " - " + option.name
                              }
                              onChange={(e, value) => {
                                if (value != null) {
                                  setSelectedCustomer({
                                    ...selectedCustomer,
                                    customer_contact_id:
                                      value.customer_contact_id,
                                    entityid: value.entityid,
                                    name: value.name,
                                    phone: value.phone,
                                    email: value.email,
                                    paymenttype: value.paymenttype,
                                    currency: value.currency,
                                    customer_id: value.customer_id,
                                    balance: value.balance,
                                    depositbalance: value.depositbalance,
                                  });
                                  handleGetCustomerData(value.customer_id);
                                  if (value.subsidiary == 2) {
                                    setBilltype("SST");
                                  } else {
                                    setBilltype("GST");
                                  }
                                } else {
                                  setSelectedCustomer(null);
                                }
                              }}
                              style={{ width: "100%" }}
                              renderInput={(params) => (
                                <FormInputNoLabel
                                  {...params}
                                  label="Customer*"
                                  textLabelColor="#000"
                                  placeholder="Please Choose Customer*"
                                  name="customer"
                                  border="1px solid #c5c5c5"
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid container spacing={3} sx={{ alignItems: "baseline" }}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        sx={{ alignItems: "baseline" }}
                      >
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">
                              Choose Sale Orders:
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Autocomplete
                              sx={{ fontStyle: "italic" }}
                              id="sales_order_id"
                              value={selectedSaleOrderID}
                              options={displayAllSaleOrderID || []} // Ensure options is always an array
                              getOptionLabel={(option) => option.sales_order_id}
                              onChange={(e, value) => {
                                if (value != null) {
                                  setSelectedSaleOrderID({
                                    ...selectedSaleOrderID,
                                    sales_order_id: value.sales_order_id,
                                  });
                                  handleGetOrderData(value.sales_order_id);
                                } else {
                                  setSelectedSaleOrderID(null);
                                  // setProductList([]);
                                  // calculateCart();
                                }
                              }}
                              style={{ width: "100%" }}
                              renderInput={(params) => (
                                <FormInputNoLabel
                                  {...params}
                                  textLabelColor="#000"
                                  placeholder="Please Choose Sale Order ID*"
                                  name="sales_order_id"
                                  border="1px solid #c5c5c5"
                                  disabled={selectedCustomer == null}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                    <div
                      style={{
                        borderBottom: "2px solid #707070",
                        padding: ".2rem 0",
                      }}
                    />
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={6}>
                        <Grid container spacing={3}>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            style={{ margin: "auto" }}
                          >
                            <Paragraph size="14px">
                              Return Reason:{" "}
                              <span
                                style={{
                                  color: "#F92000",
                                  marginLeft: "4px",
                                }}
                              >
                                *
                              </span>
                            </Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <FormInputNoLabel
                              // name="color"
                              // placeholder="Search"
                              //   disabled
                              border="1px solid #d7d7d7"
                              br="6px"
                              value={selectedReason}
                              onChange={handleChooseReason}
                              select
                            >
                              <MenuItem value="0" style={{ fontWeight: "400" }}>
                                <em style={{ color: "#878787" }}>
                                  Please Choose a Reasons
                                </em>
                              </MenuItem>
                              {reasonData != null &&
                                reasonData.map((res) => (
                                  <MenuItem value={res.name}>
                                    {res.name}
                                  </MenuItem>
                                ))}
                            </FormInputNoLabel>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            style={{ margin: "auto" }}
                          >
                            <Paragraph size="14px">Stock Return:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            {/* <Checkbox
                                  onChange={() => setStockReturn(!stockReturn)}
                                  checked={stockReturn}
                                  sx={{
                                    padding: "0 .4rem 0 0",
                                    color: "#1A5386 ",
                                    "&.Mui-checked": {
                                      color: "#1A5386 ",
                                    },
                                  }}
                                />
                                {stockReturn ? "Yes" : "No"} */}
                            <FormInputNoLabel
                              // name="color"
                              // placeholder="Search"
                              //   disabled
                              border="1px solid #d7d7d7"
                              br="6px"
                              onChange={handleChooseReturn}
                              value={chooseReturn}
                              select
                            >
                              <MenuItem value="3" style={{ fontWeight: "400" }}>
                                <em style={{ color: "#878787" }}>
                                  Please Select Return Type
                                </em>
                              </MenuItem>
                              <MenuItem value="1" style={{ color: "#000" }}>
                                Stock Return
                              </MenuItem>
                              <MenuItem value="0" style={{ color: "#000" }}>
                                No Stock Return
                              </MenuItem>
                            </FormInputNoLabel>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            style={{ margin: "auto" }}
                          >
                            <Paragraph size="14px">Full Return:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Checkbox
                              // onChange={() => setFullReturn(!fullReturn)}
                              onChange={handleSelectAll}
                              checked={fullReturn}
                              sx={{
                                padding: "0 .4rem 0 0",
                                color: "#1A5386 ",
                                "&.Mui-checked": {
                                  color: "#1A5386 ",
                                },
                              }}
                            />
                            {fullReturn ? "Yes" : "No"}
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            style={{ margin: "auto" }}
                          >
                            <Paragraph size="14px">Memo:</Paragraph>
                          </Grid>

                          <Grid item xs={12} sm={8} md={8}>
                            <FormInput
                              // value={retunDetailData.description}
                              textLabelColor="#000"
                              name="memo"
                              border="1px solid #c5c5c5"
                              mb="0"
                              onChange={handleChangeMemo}
                              // onChange={(e) => setMemo(e.target.value)}
                              multiline
                              minRows={4}
                            ></FormInput>
                          </Grid>

                          <Grid item xs={12} sm={4} md={4}>
                            <Paragraph size="14px">Upload Images:</Paragraph>
                          </Grid>
                          <Grid item xs={12} sm={8} md={8}>
                            <Box sx={{ display: "flex" }}>
                              <input
                                style={{
                                  color: "#000",
                                  border: "1px solid #eaeaea",
                                  borderRadius: 4,
                                  padding: ".4rem 1rem",
                                  width: "-webkit-fill-available",
                                  lineHeight: "1.4375em",
                                  fontSize: "1rem",
                                }}
                                type="file"
                                name="image"
                                onChange={handleChangeUploadReturn}
                                multiple
                              />
                              {!disabled ? (
                                <></>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100px",
                                    height: "35px",
                                  }}
                                >
                                  <Loader
                                    type="snipper-default"
                                    bgColor={"#878787"}
                                    size={30}
                                  />
                                </div>
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      {selectedReason == "Others" && (
                        <Grid item xs={12} sm={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              md={4}
                              style={{ margin: "auto" }}
                            >
                              <Paragraph size="14px">Others Reason:</Paragraph>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                              <FormInput
                                value={reportData.otherreason}
                                textLabelColor="#000"
                                name="otherreason"
                                border="1px solid #c5c5c5"
                                mb="0"
                                onChange={handleChangeReport}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    <br />
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12}>
                        <Card className={classes.theCard}>
                          <div className={classes.theFlexHeader2}>
                            <Paragraph size="22px" bold="600">
                              Product List
                            </Paragraph>
                          </div>
                          <br />
                          <div
                            style={{
                              borderBottom: "2px solid #707070",
                            }}
                          ></div>
                          <br />
                          <TableContainer>
                            <Table>
                              <TableHead style={{ backgroundColor: "#1A5386" }}>
                                <TableRow>
                                  {retunDetailData.status == "Open" ||
                                  retunDetailData.status == "Error" ? (
                                    <TableCell
                                      style={{
                                        borderRadius: "10px 0 0 10px",
                                      }}
                                      className={classes.theHeadTitle}
                                    >
                                      <Checkbox
                                        sx={{
                                          visibility: "hidden",
                                          color: "#fff",
                                          "&.Mui-checked": {
                                            color: "#fff",
                                          },
                                        }}
                                      />
                                    </TableCell>
                                  ) : (
                                    <></>
                                  )}

                                  <TableCell className={classes.theHeadTitle}>
                                    Item Name
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Description
                                  </TableCell>

                                  <TableCell className={classes.theHeadTitle}>
                                    Price
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Discount Amount
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Sales Quantity
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Return Quantity
                                  </TableCell>
                                  <TableCell className={classes.theHeadTitle}>
                                    Returned Quantity
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderRadius: "0 10px 10px 0",
                                    }}
                                    className={classes.theHeadTitle}
                                  >
                                    Total Price
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedItem.length != 0 &&
                                  selectedItem.map((item, index) => {
                                    return (
                                      <>
                                        {item.is_display == 1 && (
                                          <TableRow>
                                            {item.quantity ===
                                            item.returned_quantity ? (
                                              <>
                                                {retunDetailData.status ==
                                                  "Open" ||
                                                retunDetailData.status ==
                                                  "Error" ? (
                                                  <TableCell
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "5%",
                                                    }}
                                                  >
                                                    <>
                                                      {item.remainingamt !=
                                                        0 && (
                                                        <Checkbox
                                                          onChange={() =>
                                                            handleSelectItem(
                                                              index
                                                            )
                                                          }
                                                          value={defaultChecked}
                                                          disabled
                                                          checked
                                                          sx={{
                                                            color: "#00000042 ",
                                                            "&.Mui-checked": {
                                                              color:
                                                                "#00000042 ",
                                                            },
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  </TableCell>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {retunDetailData.status ==
                                                  "Open" ||
                                                retunDetailData.status ==
                                                  "Error" ? (
                                                  <TableCell
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "5%",
                                                    }}
                                                  >
                                                    <>
                                                      {item.remainingamt !=
                                                        0 && (
                                                        <Checkbox
                                                          onChange={() =>
                                                            handleSelectItem(
                                                              index
                                                            )
                                                          }
                                                          value={defaultChecked}
                                                          disabled={allSelected}
                                                          checked={item.check}
                                                          sx={{
                                                            color: "#1A5386 ",
                                                            "&.Mui-checked": {
                                                              color: "#1A5386 ",
                                                            },
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  </TableCell>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            )}

                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "15%",
                                              }}
                                            >
                                              {item.itemname != "" &&
                                              item.itemname != null
                                                ? item.itemname
                                                : "-"}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "15%",
                                              }}
                                            >
                                              {item.description != "" &&
                                              item.description != null
                                                ? item.description
                                                : "-"}
                                            </TableCell>

                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                              }}
                                            >
                                              {item.price}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                              }}
                                            >
                                              {item.discountamount}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                                textAlign: "center",
                                              }}
                                            >
                                              {item.quantity}
                                            </TableCell>

                                            {retunDetailData.status == "Open" ||
                                            retunDetailData.status ==
                                              "Error" ? (
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "10%",
                                                }}
                                              >
                                                <FormInput
                                                  value={item.return_quantity}
                                                  textLabelColor="#000"
                                                  bold="600"
                                                  mb="0"
                                                  border={
                                                    item.return_quantity >
                                                    item.remain_quantity
                                                      ? "1px solid #F90000"
                                                      : "1px solid #707070"
                                                  }
                                                  size="12px"
                                                  disabled={allSelected}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.target.value ==
                                                        "" &&
                                                      !/[1-9]/.test(event.key)
                                                    ) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  onChange={(e) =>
                                                    handleChangeQuantityItem(
                                                      e,
                                                      index
                                                    )
                                                  }
                                                />
                                              </TableCell>
                                            ) : (
                                              <TableCell
                                                style={{
                                                  background:
                                                    index % 2 == 0
                                                      ? "#E0F0F7"
                                                      : "#fff",
                                                  width: "10%",
                                                  textAlign: "center",
                                                }}
                                              >
                                                {item.return_quantity}
                                              </TableCell>
                                            )}
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                                textAlign: "center",
                                              }}
                                            >
                                              {item.returned_quantity}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                              }}
                                            >
                                              {item.subtotal}
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <br />
                          <div
                            style={{
                              borderBottom: "2px solid #f2f2f2",
                            }}
                          ></div>
                          <br />
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}></Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">Amount:</Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderData != null ? (
                                        <>{orderData.total_amount}</>
                                      ) : (
                                        <>0.00</>
                                      )}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Discount Amount:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderData != null ? (
                                        <>{orderData.discountamount}</>
                                      ) : (
                                        <>0.00</>
                                      )}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Shipping Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderData != null ? (
                                        <>{orderData.shipping_fee}</>
                                      ) : (
                                        <>0.00</>
                                      )}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">
                                      Handling Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderData != null ? (
                                        <>{orderData.handling_fee}</>
                                      ) : (
                                        <>0.00</>
                                      )}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #f2f2f2",
                                }}
                              ></div>
                              <br />
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph size="14px">Total:</Paragraph>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {orderData != null ? (
                                        <>{orderData.final_amount}</>
                                      ) : (
                                        <>0.00</>
                                      )}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </Card>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                    <div
                      className={classes.theFlexBtn}
                      style={{ marginBottom: "0" }}
                    >
                      <a
                        className={classes.theAddCustomActionBtnFill}
                        onClick={() => handleSubmitReport()}
                      >
                        {/* <CheckCircleOutline sx={{ color: "#fff" }} /> */}
                        <Paragraph margin="0 0 0 .4rem">
                          Submit Report
                        </Paragraph>
                      </a>
                    </div>
                    <br />
                    <br />
                  </div>
                </React.Fragment>
              </Section>
            }
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
